
import HttpClientToken from '../../services/HttpClientToken';
import HttpClientFileToken from '../../services/HttpClientFileToken';

import { AxiosError } from 'axios';

import { defaultHttpResponse, HttpResponse } from '../../interfaces/auth/AuthInterface';

import { ParteProps } from '../../interfaces/recepcion/ParteInterface';

import { ActualizarEstatusParams, ActualizarEstatusResponse, AgregarPartesParams, BuscarAcuerdoParams, BuscarAcuerdoResponse, ConsultaAcuerdosPendientesResponse, defaultActualizarEstatus, defaultConsultaAcuerdosPendientes, defaultDetalleAcuerdo, defaultEnviarPromocion, defaultGenerarIrregular, defaultNuevoAcuerdo, DescargarAcuerdosPendientesParams, DetalleAcuerdoResponse, EnviarPromocionParams, EnviarPromocionResponse, GenerarIrregularParams, GenerarIrregularResponse, GuardarAcuerdoParams, GuardarNotificacionesParams, NuevoAcuerdoParams, NuevoAcuerdoResponse, ObtenerResolucionesParams, ConsultaAcuerdosPendientesParams } from '../../interfaces/tribunal/AcuerdoInterface';
import { MedioImpugnacionDocumentoProps } from '../../interfaces/tribunal/MedioImpugnacionInterface';

export const BuscarAcuerdo = ( params: BuscarAcuerdoParams ) => {

    return new Promise<BuscarAcuerdoResponse[]>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClientToken.post('/Api/Acuerdo/BuscarAcuerdos', params, token)
            .then( ({ data } : { data : BuscarAcuerdoResponse[] } ) => {  
                resolve( data );                
            })
            .catch( () => {
                resolve( [] );
            });
        }

    });

}

export const NuevoAcuerdo = ( params: NuevoAcuerdoParams ) => {

    return new Promise<NuevoAcuerdoResponse>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            
            const { token } = data;

            HttpClientToken.post('/Api/Acuerdo/NuevoAcuerdo/', params, token)
            .then( ({ data } : { data : NuevoAcuerdoResponse } ) => {  
                resolve( data );                
            })
            .catch( ( error: AxiosError ) => {
                resolve( { ...defaultNuevoAcuerdo, message: error.message } );
            });

        }

    });

}

export const DetalleAcuerdo = ( id: string ) => {

    return new Promise<DetalleAcuerdoResponse>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get(`/Api/Acuerdo/DetalleAcuerdo/${ id }`, token)
            .then( ({ data } : { data : any } ) => {  
                resolve( data );                
            })
            .catch( () => {
                resolve({ ...defaultDetalleAcuerdo });
            });

        }

    });

}

export const GuardarAcuerdo = ( params: GuardarAcuerdoParams ) => {

    return new Promise<HttpResponse>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/Acuerdo/GuardarAcuerdo/', params, token)
            .then( ({ data } : { data : HttpResponse } ) => {  
                resolve( data );                
            })
            .catch( ( error: AxiosError ) => {
                resolve( { ...defaultHttpResponse, message: error.message } );
            });

        }

    });

}

export const ActualizarEstatus = ( params: ActualizarEstatusParams ) => {

    return new Promise<ActualizarEstatusResponse>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/Acuerdo/ActualizarEstatus/', params, token)
            .then( ({ data } : { data : ActualizarEstatusResponse } ) => {  
                resolve( data );                
            })
            .catch( ( error: AxiosError ) => {
                resolve( { ...defaultActualizarEstatus, message: error.message } );
            });

        }

    });

}

export const GuardarNotificaciones = ( params: GuardarNotificacionesParams ) => {

    return new Promise<HttpResponse>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/Acuerdo/GuardarNotificaciones/', params, token)
            .then( ({ data } : { data : HttpResponse } ) => {  
                resolve( data );                
            })
            .catch( ( error: AxiosError ) => {
                resolve( { ...defaultHttpResponse, message: error.message } );
            });

        }

    });

}

export const ObtenerPartesAcuerdo = ( id: number ) => {

    return new Promise<ParteProps[]>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get(`/Api/Acuerdo/ObtenerPartesAcuerdo/${ id }`, token)
            .then( ({ data } : { data : ParteProps[] } ) => {  
                resolve( data );                
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const AgregarPartesAcuerdo = ( params: AgregarPartesParams ) => {

    return new Promise<HttpResponse>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/Acuerdo/AgregarPartesAcuerdo/', params, token)
            .then( ({ data } : { data : HttpResponse } ) => {  
                resolve( data );                
            })
            .catch( ( error: AxiosError ) => {
                resolve( { ...defaultHttpResponse, message: error.message } );
            });

        }

    });

}

export const EnviarPromocion = ( params: EnviarPromocionParams ) => {

    return new Promise<EnviarPromocionResponse>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/Acuerdo/EnviarPromocion/', params, token)
            .then( ({ data } : { data : EnviarPromocionResponse } ) => {  
                resolve( data );                
            })
            .catch( ( error: AxiosError ) => {
                resolve( { ...defaultEnviarPromocion, message: error.message } );
            });

        }

    });

}

export const GenerarIrregular = ( params: GenerarIrregularParams ) => {

    return new Promise<GenerarIrregularResponse>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/Acuerdo/GenerarIrregular/', params, token)
            .then( ({ data } : { data : GenerarIrregularResponse } ) => {  
                resolve( data );                
            })
            .catch( ( error: AxiosError ) => {
                resolve( { ...defaultGenerarIrregular, message: error.message } );
            });

        }

    });

}

export const ObtenerResoluciones = ( params: ObtenerResolucionesParams ) => {

    return new Promise<MedioImpugnacionDocumentoProps[]>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/Acuerdo/ObtenerResoluciones/', params, token)
            .then( ({ data } : { data : MedioImpugnacionDocumentoProps[] } ) => {  
                resolve( data );                
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const ConsultaAcuerdosPendientes = async ( params: ConsultaAcuerdosPendientesParams ) => {

    return new Promise<ConsultaAcuerdosPendientesResponse>((resolve) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '{}' );

         if ( data ) {

            const { token } = data;

            HttpClientToken.post('/Api/Acuerdo/ConsultaAcuerdosPendientes/' , params, token)
            .then(({ data }: { data: ConsultaAcuerdosPendientesResponse }) => {
                resolve(data);
            })
            .catch( () => {
                resolve( { ...defaultConsultaAcuerdosPendientes } );
            });

        }

    });

};

export const DescargarAcuerdosPendientes = async ( params: DescargarAcuerdosPendientesParams ) => {

    return new Promise<Blob | null>( ( resolve, eject ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientFileToken.post('/Api/Acuerdo/DescargarAcuerdosPendientes', params, token)
            .then( ({ data } : { data : Blob } ) => {  
                resolve( data );                
            })
            .catch( () => {
                resolve( null );
            });

        }

    });

};